class LibraryStats {
    constructor() {
        this.sharesCount = null;
        this.commentsCount = null;
        this.mastersCount = null;
        this.uploadsCount = null;
        this.originalAlbumsCount = null;
        this.masteredAlbumsCount = null;
        this.referenceTracksCount = null;
    }
}

export { LibraryStats };
